// UX-only gate — hides the /admin route and its nav entry for everyone else. This is
// NOT the real security boundary: the server independently enforces the same allowlist
// against a verified JWT claim (server/src/utils/adminAllowlist.ts) before running
// anything, so a direct API call from a non-admin is rejected regardless of what this
// file does. Keep the two lists in sync by hand — they're different build roots and
// can't share one module.
const ADMIN_EMAILS = [
  'pankajpawar@pgpconstructionservices.com',
  'admin@pgpconstructionservices.com',
];

export function isAdminEmail(email: string | undefined | null): boolean {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.trim().toLowerCase());
}
